export function isDocumentRtl(): boolean {
  return document.documentElement.getAttribute("dir") === "rtl";
}

export function getCornerDrawerDialogPosition(): {
  right?: string;
  left?: string;
  top: string;
} {
  return isDocumentRtl()
    ? { left: "0", top: "0" }
    : { right: "0", top: "0" };
}

export function buildFixedDropdownStyle(
  trigger: HTMLElement,
  options?: { width?: number; gap?: number; isRTL?: boolean },
): Record<string, string> {
  const width = options?.width ?? 280;
  const gap = options?.gap ?? 8;
  const margin = 12;
  const isRTL = options?.isRTL ?? isDocumentRtl();
  const rect = trigger.getBoundingClientRect();
  const top = `${rect.bottom + gap}px`;

  if (isRTL) {
    const left = Math.max(
      margin,
      Math.min(rect.left, window.innerWidth - width - margin),
    );
    return {
      top,
      left: `${left}px`,
      right: "auto",
      width: `${width}px`,
    };
  }

  const left = Math.max(margin, rect.right - width);
  return {
    top,
    left: `${left}px`,
    right: "auto",
    width: `${width}px`,
  };
}
